<div class="side-menu">
  <div class="side-menu__items">
    <button mat-icon-button
            class="side-menu__close-btn"
            (click)="onCloseClick()"
            aria-label="Close menu">
      <i class="fas fa-times"></i>
    </button>
    <a
      *ngFor="let item of menuItems"
      class="side-menu__item"
      [routerLink]="item.route"
      routerLinkActive="side-menu__item--active"
      [routerLinkActiveOptions]="{ exact: false }"
      (click)="onMenuItemClick()"
    >
      <i class="fas {{ item.icon }} side-menu__icon"></i>
      <span class="side-menu__label">{{ item.label | transloco }}</span>
    </a>
  </div>
</div>
